import React, { useState } from 'react'
import { useResume } from '../ResumeProvider'
import { Button } from '~/lib/ui/button'
import { PlusIcon } from '@heroicons/react/24/outline'
import { EditableHeading, newKey } from './common'
import { EditorItemProvider } from './EditorItemProvider'
import AdditionalInformationItem from './AdditionalInformationItem'
import { useTemplate } from '~/lib/pdf'
import { useTranslation } from '~/hooks/useTranslation'

const AdditionalInformationEditor = () => {
  const { t } = useTranslation('AdditionalInformationEditor')
  const { resumeDocument, setResumeDocument } = useResume()
  const [activeIndex, setActiveIndex] = useState(-1)
  const additionalInfo = resumeDocument?.additionalInfo || []

  const { editorFieldEnabled } = useTemplate()

  const addAdditionalInfo = () => {
    const newIndex = additionalInfo?.length || 0
    const updatedadditionalInfo = [...additionalInfo, {}]

    setResumeDocument({
      ...resumeDocument,
      additionalInfo: updatedadditionalInfo,
    })
    setActiveIndex(newIndex)
  }

  if (!editorFieldEnabled('additionalInfo')) return null

  return (
    <div className="flex flex-col">
      <div className="mb-4 flex flex-row">
        <EditableHeading
          title={t('additional_information')}
          description={t('add_any_additional_information')}
          settingName="additionalInfoHeading"
        />
      </div>
      <div className="pb-4 tracking-[0.024px]">
        {t('add_any_additional_information')}
      </div>
      {additionalInfo.map((item, index) => {
        item.key = item.key || newKey()
        return (
          <div key={item.key}>
            <EditorItemProvider
              sectionName="additionalInfo"
              index={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              item={item}
            >
              <AdditionalInformationItem />
            </EditorItemProvider>
          </div>
        )
      })}
      <Button onClick={addAdditionalInfo} className="max-w-min">
        {t('add_additional_information')}
        <PlusIcon className="ml-2 w-5" />
      </Button>
    </div>
  )
}
export default AdditionalInformationEditor
